<template>
  <v-card height="auto">
    <vue-card-title
      :title="
        actionData && actionData.given_name ? 'Update User' : 'Create User'
      "
      :subtitle="
        actionData && actionData.given_name
          ? 'Here you can update the existing CRM user.'
          : 'Here you can create new CRM user.'
      "
      :icon="$getIcon('mdiFileDocumentOutline')"
      closable
      dark
      @close="$emit('close')"
    ></vue-card-title>
    <v-divider></v-divider>
    <v-card-text class="py-4 scrollbar-md">
      <v-row no-gutters class="pa-0 ma-0">
        <v-col v-if="formValidator.getError('non_field_errors')">
          <v-alert shaped outlined text type="error">
            {{ formValidator.getError("non_field_errors") }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" cols="12" class="py-0">
          <v-text-field
            v-model="formValues.given_name"
            label="First Name *"
            counter="50"
            :error-messages="formValidator.getError('given_name')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="12" class="py-0">
          <v-text-field
            v-model="formValues.middle_name"
            label="Middle Name"
            counter="50"
            :error-messages="formValidator.getError('middle_name')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="12" class="py-0">
          <v-text-field
            v-model="formValues.family_name"
            label="Last Name *"
            counter="50"
            :error-messages="formValidator.getError('family_name')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="4" class="py-0">
          <vue-auto-complete
            v-model="formValues.organization"
            :endpoint="organizationEndpoint"
            label="Organization *"
            :prepend-inner-icon="$getIcon('mdiInformationOutline')"
            :error-messages="formValidator.getError('organization')"
            :disabled="actionData && actionData.given_name"
            item-text="name"
            item-value="slug"
          ></vue-auto-complete>
        </v-col>
        <v-col md="4" cols="12" class="py-0">
          <v-text-field
            v-model="formValues.email"
            label="Email *"
            counter="50"
            :error-messages="formValidator.getError('email')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="12" class="py-0">
          <v-select
            v-model="formValues.gender"
            :error-messages="formValidator.getError('gender')"
            label="Gender *"
            :items="genderOptions"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-select>
        </v-col>
        <v-col md="4" cols="12">
          <image-uploader v-model="formValues.picture"></image-uploader>
        </v-col>
        <v-col v-if="actionData && actionData.given_name" md="4" cols="12" class="py-0">
          <label class="caption">User Status</label>
          <v-switch
      v-model="formValues.is_active"
    ></v-switch>
        </v-col>
      </v-row>
      <v-row v-if="actionData && !actionData.given_name">
        <v-col md="4" cols="12">
          <v-text-field
            v-model="formValues.password"
            label="Enter Password"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
            :append-icon="$getIcon('mdiEyeOutline')"
            :type="passwordShow ? 'text' : 'password'"
            @click:append="passwordShow = !passwordShow"
          >
          </v-text-field>
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field
            v-model="formValues.confirm_password"
            label="Confirm Password"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
            :append-icon="$getIcon('mdiEyeOutline')"
            :type="confirmPasswordShow ? 'text' : 'password'"
            @click:append="confirmPasswordShow = !confirmPasswordShow"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn text @click="$emit('close')" class="text-capitalize">
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="indigo"
            class="white--text text-capitalize"
            :disabled="loading"
            @click="submit()"
          >
            {{ actionData && actionData.given_name ? "Update" : "Create" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
import ImageUploader from "@/components/common/layout_utils/ImageUploader";
export default {
  components: { ImageUploader },
  props: {
    actionData: {
      type: [Object, Array],
      default: undefined
    }
  },
  data() {
    return {
      formValues: JSON.parse(JSON.stringify(this.actionData)) || {},
      loading: false,
      formValidator: new FormValidator(),
      organizationEndpoint: "/api/v1/org/",
      genderOptions: ["Male", "Female", "Other"],
      passwordShow: false,
      confirmPasswordShow: false,
      profilePicture: {
        dialog: false,
        name: "",
        url: ""
      },
      endpoint: "/api/v1/users/"
    };
  },
  methods: {
    submit() {
      if (this.actionData && this.actionData.given_name) {
        this.updateForm();
      } else {
        this.createForm();
      }
    },
    isNewImage(s) {
      return !!s.match(";base64");
    },
    createFormValues() {
      const postData = JSON.parse(JSON.stringify(this.formValues));
      if (
        (postData.picture && !this.isNewImage(postData.picture)) ||
        !postData.picture
      ) {
        delete postData.picture;
      }
      return postData;
    },
    createForm() {
      this.loading = true;
      this.$axios
        .$post(this.endpoint, this.createFormValues())
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created User.`,
            color: "green"
          });
          this.$emit("create");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateForm() {
      this.loading = true;
      let endpoint = this.endpoint + `${this.actionData.id}/`;
      this.$axios
        .$patch(endpoint, this.createFormValues())
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated User.`,
            color: "green"
          });
          this.$emit("update");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
